var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"form-label"},[_c('span',{staticClass:"required-label",class:{required: _vm.required}},[_vm._v(_vm._s(_vm.required ? '必須' : '任意'))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }